import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.0043 0.590088L2.00015 0.585938L0.585938 2.00015L2.58579 4H2V10C3.65685 10 5 11.3431 5 13C5 14.6569 3.65685 16 2 16V22H8C8 20.3431 9.34315 19 11 19C12.6569 19 14 20.3431 14 22H20V21.4142L22.0002 23.4144L23.4101 22.0045L2 0.594389L2.0043 0.590088Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.2257 15.9916C21.7771 15.8763 23 14.5809 23 13C23 11.3431 21.6569 10 20 10V4H14C14 2.34315 12.6569 1 11 1C9.41906 1 8.12374 2.22288 8.00836 3.77432L20.2257 15.9916Z"}}]};

const ExtensionOffFilled = Vue.extend<IconProps>({
  name: 'ExtensionOffFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'extension-off-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ExtensionOffFilled;
